import { useQuery } from '@tanstack/react-query';
import { telemetriaApi } from '../api/telemetria';

/**
 * Leitura agregada de uso (aba Uso da Auditoria). `origem` vazio = todas.
 * A queryKey inclui `dias` e `origem` normalizado ('' quando ausente) — em
 * teoria dedupa com a sonda "existe QUALQUER dado mobile?" quando `dias` E
 * `origem` batem os dois. Na prática nunca bate: a sonda (ver `AbaUso.tsx`)
 * usa `dias=365` fixo (teto do clamp), enquanto o seletor de período só
 * oferece 7/30/90 — são sempre 2 requests distintos, não uma cacheada.
 */
export function useTelemetriaUso(dias: number, origem?: string, incluirAdmin = false) {
  return useQuery({
    queryKey: ['telemetria', 'uso', dias, origem ?? '', incluirAdmin],
    queryFn: () => telemetriaApi.uso({ dias, origem, incluirAdmin }),
    staleTime: 60 * 1000,
  });
}
